import { useContent } from "../hooks/useContent";
import { logger } from "../lib/log.utils";

const Footer = () => {
	const {data,isLoading} = useContent();
	const footerData = data?.footer || {};
	const contactData = data?.contact || {};
	return (
		<footer className="bg-maroon-deep py-10 px-4 border-t border-gold/20">
			<div className="max-w-6xl mx-auto text-center">
				<h3 className="font-display text-2xl font-bold text-gold-gradient mb-2">{footerData.brand || "SWAR NRITYAM"}</h3>
				<p className="text-cream/50 font-heading text-sm italic tracking-wider mb-6">
					{footerData.tagline || "Dance • Music • Art • Rhythm of Joy"}
				</p>
				<div className="w-16 h-px bg-gold/30 mx-auto mb-6" />
				<p className="text-cream/40 font-body text-xs">
					© {new Date().getFullYear()} {footerData.brand || "Swar Nrityam"}, {contactData.location || "Balipara"}. All rights reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;
